import styled from "styled-components";
import { fadeIn, pulse } from "../../styles/Animations";
import ReckewegBackground from '../../assets/Lines/reckeweg-background.png';
import TegorBackground from '../../assets/Lines/tegor-background.png';
import HelixorBackground from '../../assets/Lines/helixor-background.png';
import SymbioBackground from '../../assets/Lines/symbio-background.png';
import RegenhialBackground from '../../assets/Lines/regenhial-background.png';

const backgroundMap = {
  tegor: TegorBackground,
  'dr-reckeweg': ReckewegBackground,
  helixor: HelixorBackground,
  'symbio-pharm': SymbioBackground,
  regenhial: RegenhialBackground
};

export const ProductBannerContainer = styled.div`
  height: 15vh;
  background-image: url(${props => backgroundMap[props.lineId] || ReckewegBackground});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.5s ease-in-out;

  img{
    width: 30%;
    height: auto;
    max-width: 150px;
    margin: 0 auto;
  }


  @media (max-width: 1100px) {
    /* Tablets */
    height: 10vh;
  }

  @media (max-width: 550px) {
    /* Phones */
    height: 10vh;
  }
`;
